import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-analise-venda-bi01-lista-grid',
  templateUrl: './analise-venda-bi01-lista-grid.component.html',
  styleUrls: [ './../../../../../../../assets/styles/styles.grid-analise.css']
})
export class AnaliseVendaBi01ListaGridComponent implements OnInit {

  analiseVendaTranslate = {
    "Previsão Vendas Clothing": "rmpv.analiseVenda.previsaoVendaClothing",
    "Previsão Vendas Peças": "rmpv.analiseVenda.previsaoVendaPecas",
    "Previsão Vendas Outros": "rmpv.analiseVenda.previsaoVendaOutros",
    "Previsão Vendas Mão de Obra": "rmpv.analiseVenda.previsaoVendaMaoObra",
    "Previsão Vendas Acessórios": "rmpv.analiseVenda.previsaoVendaAcessorios",
    "Vendas Peças Revisões": "rmpv.analiseVenda.vendasPecasRevisoes",
    "Vendas Peças Cliente": "rmpv.analiseVenda.vendasPecasCliente",
    "Vendas Peças Balcão": "rmpv.analiseVenda.vendaPecasBalcao",
    "Vendas Peças Seguros/Franquias": "rmpv.analiseVenda.vendasPecasSegurosFranquias",
    "Vendas Peças Garantia": "rmpv.analiseVenda.vendasPecasGarantia",
    "Vendas Peças Recall": "rmpv.analiseVenda.vendasPecasRecall",
    "Vendas MO Seguros/Franquias": "rmpv.analiseVenda.vendasMOSegurosFranquias",
    "Vendas MO Cliente": "rmpv.analiseVenda.vendasMOCliente",
    "Vendas MO Garantia": "rmpv.analiseVenda.vendasMOGarantia",
    "Vendas MO Recall": "rmpv.analiseVenda.vendasMORecall",
    "Vendas MO Acessório": "rmpv.analiseVenda.vendasMOAcessorio",
    "Vendas MO Revisões": "rmpv.analiseVenda.vendasMORevisoes",
    // "% Realizado MO / Previsão MO": "rmpv.analiseVenda.realizadoMOPrevisaoMO",
    "Vendas Acessórios Balcão": "rmpv.analiseVenda.vendasAcessoriosBalcao",
    "Vendas Acessórios Oficina": "rmpv.analiseVenda.vendasAcessoriosOficina",
    "Vendas Clothing": "rmpv.analiseVenda.vendasClothing",
    "Vendas Outros": "rmpv.analiseVenda.vendasOutros",
    "Vendas Internas/Cortesias": "rmpv.analiseVenda.vendasInterna",
    "Vendas MO Internas/Cortesias": "rmpv.analiseVenda.vendasInternaMO",
    "Total Vendas PCA": "rmpv.analiseVenda.totalVendasPCA",
    "% Realizado Vendas PCA / Previsão": "rmpv.analiseVenda.realizadoVendasPCAPrevisao",
    "Total Vendas MO + PCA": "rmpv.analiseVenda.totalVendasMOPCA",
    "% Realizado MO + PCA / Previsão MO + PCA": "rmpv.analiseVenda.realizadoMOPCAPrevisaoMOPCA",
    "Relação PO / MO": "rmpv.analiseVenda.relacaoPOMO",
    "% Vendas Peças Oficina / Total Vendas PCA": "rmpv.analiseVenda.vendasPecasOficinaTotalVendasPCA",
  };

  @Input() dados: any;
  @Input() anoFiltro: any;
  @Input() mesInicial: any;
  @Input() mesFinal: any;

  constructor() { }

  ngOnInit(): void {
  }

  getTranslate(value) {
    return this.analiseVendaTranslate[value];
  }
}
